import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

const DEFAULTS = {
  notifications_enabled: true,
  discord_webhook_url: null,
  odds_format: "decimal",
  currency: "GBP",
};

export function SettingsProvider({ userId, children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULTS, ...data });
    } catch {
      setSettings(DEFAULTS);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (!userId) { setSettings(DEFAULTS); setLoaded(false); return; }
    load();
  }, [userId, load]);

  const save = async (patch) => {
    const { data } = await api.put("/settings", patch);
    setSettings({ ...DEFAULTS, ...data });
    return data;
  };

  return (
    <SettingsContext.Provider value={{ settings, save, refresh: load, loaded }}>
      {children}
    </SettingsContext.Provider>
  );
}
